var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormsicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_508_32822)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#FEFEFE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9375 16.5C23.9349 16.4253 23.9034 16.3545 23.8496 16.3026L21.2812 13.9912V10.6562C21.2789 10.5863 21.2512 10.5196 21.2034 10.4685L18.8128 8.07783C18.7613 8.03066 18.6948 8.00311 18.625 8H10.9219C10.8514 8 10.7839 8.02799 10.734 8.0778C10.6842 8.12761 10.6562 8.19518 10.6562 8.26562V13.9912L8.08792 16.3021C8.03403 16.3542 8.0025 16.4251 8 16.5V24.7344C8.00089 24.8045 8.02917 24.8716 8.07879 24.9212C8.12841 24.9708 8.19546 24.9991 8.26562 25H23.6719C23.7421 24.9992 23.8092 24.971 23.8589 24.9214C23.9085 24.8717 23.9367 24.8046 23.9375 24.7344V16.5ZM23.4062 17.0201V24.1388L19.0133 20.201L23.4062 17.0201ZM23.2498 16.4774L21.2812 17.9028V14.7057L23.2498 16.4774ZM18.3594 8.53125V10.6562C18.3594 10.7267 18.3874 10.7943 18.4372 10.8441C18.487 10.8939 18.5546 10.9219 18.625 10.9219H20.75V18.2874L18.6085 19.8378L16.1462 17.6302C16.0974 17.5865 16.0343 17.5623 15.9688 17.5623C15.9032 17.5623 15.8401 17.5865 15.7913 17.6302L13.329 19.8378L11.1875 18.2874V8.53125H18.3594ZM8.53125 17.0201L12.9242 20.201L8.53125 24.1394V17.0201ZM10.6562 17.9028L8.6877 16.4774L10.6562 14.7057V17.9028ZM8.9597 24.4688C12.4646 21.3264 14.1604 19.8065 15.9688 18.1849L22.9778 24.4688H8.9597Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11H16",
    stroke: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13H16",
    stroke: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13H19.5",
    stroke: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15H16",
    stroke: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15H19.5",
    stroke: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_508_32822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsicon);
export default __webpack_public_path__ + "static/media/formsicon.ef213f9d.svg";
export { ForwardRef as ReactComponent };var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormsicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_508_32822)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#FEFEFE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9375 16.5C23.9349 16.4253 23.9034 16.3545 23.8496 16.3026L21.2812 13.9912V10.6562C21.2789 10.5863 21.2512 10.5196 21.2034 10.4685L18.8128 8.07783C18.7613 8.03066 18.6948 8.00311 18.625 8H10.9219C10.8514 8 10.7839 8.02799 10.734 8.0778C10.6842 8.12761 10.6562 8.19518 10.6562 8.26562V13.9912L8.08792 16.3021C8.03403 16.3542 8.0025 16.4251 8 16.5V24.7344C8.00089 24.8045 8.02917 24.8716 8.07879 24.9212C8.12841 24.9708 8.19546 24.9991 8.26562 25H23.6719C23.7421 24.9992 23.8092 24.971 23.8589 24.9214C23.9085 24.8717 23.9367 24.8046 23.9375 24.7344V16.5ZM23.4062 17.0201V24.1388L19.0133 20.201L23.4062 17.0201ZM23.2498 16.4774L21.2812 17.9028V14.7057L23.2498 16.4774ZM18.3594 8.53125V10.6562C18.3594 10.7267 18.3874 10.7943 18.4372 10.8441C18.487 10.8939 18.5546 10.9219 18.625 10.9219H20.75V18.2874L18.6085 19.8378L16.1462 17.6302C16.0974 17.5865 16.0343 17.5623 15.9688 17.5623C15.9032 17.5623 15.8401 17.5865 15.7913 17.6302L13.329 19.8378L11.1875 18.2874V8.53125H18.3594ZM8.53125 17.0201L12.9242 20.201L8.53125 24.1394V17.0201ZM10.6562 17.9028L8.6877 16.4774L10.6562 14.7057V17.9028ZM8.9597 24.4688C12.4646 21.3264 14.1604 19.8065 15.9688 18.1849L22.9778 24.4688H8.9597Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11H16",
    stroke: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13H16",
    stroke: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13H19.5",
    stroke: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15H16",
    stroke: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15H19.5",
    stroke: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_508_32822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsicon);
export default __webpack_public_path__ + "static/media/formsicon.ef213f9d.svg";
export { ForwardRef as ReactComponent };